import { Stack } from '@mui/material';
import { z } from 'zod';

import { api } from 'common';

import { type AsynchronousJobVariant, RequiredStringSchema } from './common';
import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

import JobKind = api.RpaJob.Kind;

export const ExportSocialHistoryVariant: AsynchronousJobVariant = {
  schema: z.object({
    jobKind: z.literal(JobKind.ExportSocialHistory),
    payload: z.object({
      previsitFormSetId: RequiredStringSchema,
    }),
  }),
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockValueTemplateField
          fieldName="config.payload.previsitFormSetId"
          label="Form Set Id"
          helperText="Enter the reference to the form set id"
          placeholder="e.g. {{form.data.formSet.id}}"
        />
      </Stack>
    );
  },
};
